import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Page from "../../components/general/page";
import CommercialistaProfile from "../../components/profile/commercialista";
import ClienteProfile from "../../components/profile/cliente";
import { FormattedMessage } from "react-intl";

class ProfileView extends Component {
  static propTypes = {
    companySelected: PropTypes.string,    
    myType: PropTypes.string,
    pageRef:PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      stateAccountantSelected: null
    };
  }

  componentDidMount() {
    localStorage.setItem("inClassificator", false);
  }

  render() {
    const {
      companySelected,      
      myType,
      pageRef
    } = this.props;

    return (
      <Page
        pageRef={pageRef}
        activePage="/"
        className={"contentStructure"} 
        title={<FormattedMessage id="profile.title" />}
      >
        {myType === "STUDIO" ? (
          <div>
            <CommercialistaProfile />
          </div>
        ) : companySelected ? (
          <div>
            <ClienteProfile />
          </div>
        ) : null}
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    companySelected: state.main.companySelected,
    myType: state.main.myType
  };
}

export default connect(mapStateToProps, null)(ProfileView);
